<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="EventCd" class="form-label">競技種別</label>
          <div class="input-group">
            <span class="input-group-text">{{
              license_type_obj.event_cd
            }}</span>
            <bs-select
              :options="event_cd_list"
              v-model="license_type_obj.event_cd"
              :null-option="false"
              id="EventCd"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="col-6">
          <label for="LicenseCd" class="form-label">ライセンス</label>
          <div class="input-group">
            <span class="input-group-text">{{
              license_type_obj.license_cd
            }}</span>
            <bs-select
              :options="license_cd_list"
              v-model="license_type_obj.license_cd"
              :null-option="false"
              id="LicenseCd"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="event_cd_obj.sort"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-4">
          <label for="LicenseCd" class="form-label">競技略称</label>
          <div>
            {{ get_event_short_label(license_type_obj.event_cd) }}
          </div>
        </div>
        <div class="col-2">
          <label for="LicenseCd" class="form-label">ライセンス略称</label>
          <div>
            {{ get_license_param(license_type_obj.license_cd, 'short_label') }}
          </div>
        </div>
        <div class="col-2">
          <label for="LicenseCd" class="form-label">ライセンス種別</label>
          <div>
            {{ get_license_param(license_type_obj.license_cd, 'class_label') }}
          </div>
        </div>
        <div class="col-2">
          <label for="LicenseCd" class="form-label">カテゴリ</label>
          <div>
            {{
              get_license_param(license_type_obj.license_cd, 'category_label')
            }}
          </div>
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'

export default {
  name: 'AreaRegionDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'ライセンスコードデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      license_class_obj: [],
      license_category_obj: [],
      event_cd_obj: [],
      license_cd_obj: [],
      license_type_obj: {}
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseCdObj', response)
          this.license_type_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.license_type_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.license_type_obj,
          target: 'license_type'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadLicenseCdObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    get_event_data: function () {
      const event_cd_list = this.event_cd_list
      return function (event_cd) {
        return event_cd_list.find(event => event.event_cd == event_cd)
      }
    },
    get_event_label: function () {
      const get_func = this.get_event_data
      return function (event_cd) {
        if (get_func(event_cd)) {
          return get_func(event_cd).label
        }
        return ''
      }
    },
    get_event_short_label: function () {
      const get_func = this.get_event_data
      return function (event_cd) {
        if (get_func(event_cd)) {
          return get_func(event_cd).short_label
        }
        return ''
      }
    },
    get_license_data: function () {
      const license_cd_list = this.license_cd_list
      return function (license_cd) {
        return license_cd_list.find(license => license.license_cd == license_cd)
      }
    },
    get_license_label: function () {
      const get_func = this.get_license_data
      return function (license_cd) {
        if (get_func(license_cd)) {
          return get_func(license_cd).label
        }
        return ''
      }
    },
    get_license_param: function () {
      const get_func = this.get_license_data
      return function (license_cd, param) {
        if (
          typeof get_func(license_cd) === 'object' &&
          (typeof get_func(license_cd)[param] === 'string' ||
            typeof get_func(license_cd)[param] === 'number')
        ) {
          return get_func(license_cd)[param]
        }
        return ''
      }
    },
    get_license_print_label: function () {
      const get_func = this.get_license_data
      return function (license_cd) {
        if (get_func(license_cd)) {
          return get_func(license_cd).print_label
        }
        return ''
      }
    },
    get_class_data: function () {
      const class_list = this.license_class_list
      return function (class_cd) {
        return class_list.find(cls => cls.key == class_cd)
      }
    },
    get_class_label: function () {
      const get_func = this.get_class_data
      return function (pref_cd) {
        if (get_func(pref_cd)) {
          return get_func(pref_cd).label
        }
        return ''
      }
    },
    get_category_data: function () {
      const category_list = this.license_category_list
      return function (category_cd) {
        return category_list.find(cate => cate.key == category_cd)
      }
    },
    get_category_label: function () {
      const get_func = this.get_category_data
      return function (cateogry_cd) {
        if (get_func(cateogry_cd)) {
          return get_func(cateogry_cd).label
        }
        return ''
      }
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists
        .map(list => {
          list.key = list.license_cd
          list.class_label = this.get_class_label(list.license_class)
          list.category_label = this.get_category_label(list.license_category)
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    }
  },

  async created() {
    await this.loadLicenseCdList()
    await this.loadEventCdList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadLicenseTypeObj()
      this.btnLabel = '更新'
    } else {
      this.license_type_obj = {
        id: 0,
        label: '',
        license_cd: '',
        event_cd: '',
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'ライセンス種別データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
